import React from 'react';

/**
 * @typedef {ReturnType<typeof import('../languages').eng> | ReturnType<typeof import('../languages').heb>} LabelsContextType
 */

/**
 * @type {React.Context<LabelsContextType>}
 */
export const LabelsContext = React.createContext([{}, () => {}]);

/**
 * @typedef {import('../components/style/themes')['default']} ThemeContextType
 */

/**
 * @type {React.Context<ThemeContextType>}
 */

export const ThemeContext = React.createContext([{}, () => {}]);
export const UserContext = React.createContext([{}, () => {}]);
export const SocketContext = React.createContext([{}, () => {}]);
